import TotalResultsBanner from './TotalResultsBanner';

export default TotalResultsBanner;
